import { routerMiddleware } from 'connected-react-router';
// import history from 'constants/history';
// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore, Store } from 'redux';
import { PersistedState, Persistor, persistReducer, persistStore } from 'redux-persist';
import localStorage from 'redux-persist/es/storage';
import createSagaMiddleware from 'redux-saga';

import handlePersistUpgrade from './handlePersistUpgrade';
import createRootReducer from './rootReducer';
import rootSaga from './rootSaga';
import { RootState } from './types';

const history = createBrowserHistory();

handlePersistUpgrade();

const persistConfig = {
  key: 'root',
  whitelist: ['auth', 'user', 'settings'],
  blacklist: ['auth'],
  storage: localStorage,
};
const persistedReducer = persistReducer(persistConfig, createRootReducer(history));

const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware, routeMiddleware];

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export { history };

export default function configureStore(
  preloadedState?: RootState & PersistedState,
): { store: Store<RootState>; persistor: Persistor } {
  const store = createStore(
    persistedReducer, // root reducer with router state
    preloadedState,
    composeEnhancers(applyMiddleware(...middlewares)),
  );

  const persistor = persistStore(store);

  sagaMiddleware.run(rootSaga);

  return { store, persistor };
}
